import React from "react";
import { HeartPulse } from "lucide-react";

const TONE = { A: "bg-emerald-600 text-white", B: "bg-sky-600 text-white", C: "bg-amber-500 text-white", D: "bg-rose-600 text-white" };

export default function HealthScoreChip({ score, size = "sm" }) {
  if (!score) return null;
  const p = score.parts || {};
  const title = `Health ${score.score}/100 (${score.grade})\nVisits 30d: ${p.visits}/30 (${score.visits_30d} visits)\nFollow-ups: ${p.followups}/20 (${score.overdue_followups} overdue)\nRisk: ${p.risk}/20${score.at_risk ? " (at risk)" : ""}\nCoverage: ${p.coverage}/20 (${score.weekdays_covered}/5 weekdays)\nStatus: ${p.status}/10`;
  const cls = size === "lg" ? "px-3 py-1.5 text-sm gap-1.5" : "px-1.5 py-0.5 text-[10px] gap-1";
  return (
    <span title={title} className={`inline-flex items-center rounded-full font-mono-plex font-bold ${cls} ${TONE[score.grade]}`} data-testid="health-score-chip">
      <HeartPulse className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} /> {score.score}<span className="opacity-80 font-normal">· {score.grade}</span>
    </span>
  );
}
